import type { FastFeedBuyerRow } from "@/api/types";
import { Panel } from "@/components/ui";

function formatUsdg(v: number): string {
  if (v >= 1_000_000) return `$${(v / 1_000_000).toFixed(2)}M`;
  if (v >= 1_000) return `$${(v / 1_000).toFixed(2)}K`;
  return `$${v.toFixed(2)}`;
}

interface FastFeedBuyersTableProps {
  rows: FastFeedBuyerRow[];
  loading?: boolean;
}

export function FastFeedBuyersTable({ rows, loading = false }: FastFeedBuyersTableProps) {
  return (
    <Panel title="TOP BUYERS (ALL-TIME)">
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
          <thead>
            <tr
              style={{
                borderBottom: "1px solid var(--color-border)",
                color: "var(--color-text-muted)",
                fontSize: 10,
                textTransform: "uppercase",
                letterSpacing: "0.06em",
              }}
            >
              <th style={{ padding: "6px 8px", textAlign: "left", fontWeight: 500 }}>#</th>
              <th style={{ padding: "6px 8px", textAlign: "left", fontWeight: 500 }}>Address</th>
              <th style={{ padding: "6px 8px", textAlign: "right", fontWeight: 500 }}>
                Total (USDG)
              </th>
              <th style={{ padding: "6px 8px", textAlign: "right", fontWeight: 500 }}>Share</th>
              <th style={{ padding: "6px 8px", textAlign: "right", fontWeight: 500 }}>Payments</th>
            </tr>
          </thead>
          <tbody>
            {loading
              ? Array.from({ length: 10 }, (_, i) => (
                  // biome-ignore lint/suspicious/noArrayIndexKey: skeleton rows
                  <tr key={i}>
                    {Array.from({ length: 5 }, (_, j) => (
                      // biome-ignore lint/suspicious/noArrayIndexKey: skeleton cells
                      <td key={j} style={{ padding: "6px 8px" }}>
                        <div
                          className="skeleton"
                          style={{ height: 14, borderRadius: 2, width: "80%" }}
                        />
                      </td>
                    ))}
                  </tr>
                ))
              : rows.map((row, idx) => (
                  <tr
                    key={row.buyer_address}
                    style={{ borderBottom: "1px solid var(--color-border)" }}
                  >
                    <td
                      style={{
                        padding: "7px 8px",
                        color: "var(--color-text-muted)",
                        fontVariantNumeric: "tabular-nums",
                        width: 32,
                      }}
                    >
                      {idx + 1}
                    </td>
                    <td style={{ padding: "7px 8px" }}>
                      <span
                        style={{
                          fontFamily: "var(--font-mono)",
                          fontSize: 11,
                          wordBreak: "break-all",
                        }}
                      >
                        {row.buyer_address}
                      </span>
                    </td>
                    <td
                      style={{
                        padding: "7px 8px",
                        textAlign: "right",
                        fontVariantNumeric: "tabular-nums",
                        color: "var(--color-text-primary)",
                      }}
                    >
                      {formatUsdg(row.total_usdg)}
                    </td>
                    <td
                      style={{
                        padding: "7px 8px",
                        textAlign: "right",
                        fontVariantNumeric: "tabular-nums",
                        color: "var(--color-text-muted)",
                      }}
                    >
                      {row.share_pct.toFixed(2)}%
                    </td>
                    <td
                      style={{
                        padding: "7px 8px",
                        textAlign: "right",
                        fontVariantNumeric: "tabular-nums",
                        color: "var(--color-text-muted)",
                      }}
                    >
                      {row.payment_count.toLocaleString()}
                    </td>
                  </tr>
                ))}
          </tbody>
        </table>
        {!loading && rows.length === 0 && (
          <div
            style={{
              padding: "32px 0",
              textAlign: "center",
              color: "var(--color-text-muted)",
              fontSize: 12,
            }}
          >
            No buyer data available
          </div>
        )}
      </div>
    </Panel>
  );
}
